module.exports = __webpack_public_path__ + "img/power_settings_circle.2786f625.svg";